import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { DatePicker } from "../../../components/ui/date-picker";
import { format } from "date-fns";

export const StartDate = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Start date</h3>
      <FormField<FiltersFormT, "charterStartDate">
        name="charterStartDate"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <DatePicker
                onChange={(v) => {
                  field.onChange(v ? format(v, "yyyy-MM-dd") : null);
                  return new Date(v);
                }}
                value={field.value ? new Date(field.value) : undefined}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
